import { render, staticRenderFns } from "./ConfigurationMarkdown.vue?vue&type=template&id=2783e670&"
import script from "./ConfigurationMarkdown.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConfigurationMarkdown.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports